import { render, staticRenderFns } from "./LoadingDiv.vue?vue&type=template&id=b8f29970&scoped=true&"
import script from "./LoadingDiv.vue?vue&type=script&lang=js&"
export * from "./LoadingDiv.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDiv.vue?vue&type=style&index=0&id=b8f29970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f29970",
  null
  
)

export default component.exports